import { render, staticRenderFns } from "./EdgeTrimmerSettings.vue?vue&type=template&id=25285b13"
import script from "./EdgeTrimmerSettings.vue?vue&type=script&lang=js"
export * from "./EdgeTrimmerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports